import { useKeycloak } from '@react-keycloak/web';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface IPrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<IPrivateRouteProps> = ({ children }) => {
  const { keycloak } = useKeycloak();
  const location = useLocation();

  if (!keycloak.authenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children as React.ReactElement;
};

export default PrivateRoute;
